var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerciful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    display: "inline"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.37620222,0,0,0.37620222,29.887912,33.057904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 130.42835,75.893808 c 8.316,22 14.481,30.083002 25.03,51.576002 10.238,20.862 -4.934,41.824 -25.03,41.824 -20.096,0 -35.270004,-20.963 -25.028,-41.824 10.545,-21.493 16.344,-29.576002 25.028,-51.576002 z M -12.909711,-54.230552 c -36.018674,0 -59.80826,22.161541 -59.80826,55.4057072 0,19.4915648 9.459274,41.2670428 31.150135,61.1373318 L 51.799503,149.03446 145.08377,62.312487 c 21.69087,-19.867963 31.15014,-41.645767 31.15014,-61.1373318 0,-33.2441662 -23.77216,-55.4057072 -59.80826,-55.4057072 -33.566819,0 -44.97643,14.536932 -64.626147,35.552688 C 32.152274,-39.69362 20.654618,-54.230552 -12.909711,-54.230552 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerciful);
export default __webpack_public_path__ + "static/media/merciful.eeb8637fe94b061c7056b21a6604c685.svg";
export { ForwardRef as ReactComponent };